import * as React from "react";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import { Paths } from "../../../../constants";
import { SpeakerGuidelines } from "../../../../containers/abstracts/components";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";

interface OwnProps {
    api: Api;
    abstract: M.Abstract.Abstract;
    eventId: number;
    onSubmit: (model: Forms.AdminAbstract.AbstractPermissionsData, body: any) => void;
}

interface OwnState {
}

export class PermissionsForm extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);
        const formModel = new Forms.AdminAbstract.AbstractPermissions();
        this.state = {
            ...this.getInitialState(formModel),
        };
    }

    public componentDidMount() {
        this.setFormData(this.props.abstract);
    }

    public setFormData(abstract: M.Abstract.Abstract) {
        const formModel = this.getFormModel() as Forms.AdminAbstract.AbstractPermissions;
        formModel.data.agreedToRepurposingContent = abstract.agreedToRepurposingContent;
        formModel.data.agreedToSpeakerGuidelines = abstract.agreedToSpeakerGuidelines;
        formModel.data.agreedToUsagePermission = abstract.agreedToUsagePermission;
    }

    public render() {
        const formModel = this.getFormModel() as Forms.AdminAbstract.AbstractPermissions;
        const speakerGuidelinesErrors = this.getFieldErrors("agreedToSpeakerGuidelines");
        const cancelLink = Paths.AdminAbstractDetails(this.props.eventId, this.props.abstract.guid);

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onValidSubmit={async (model) => this.handleSubmit(model)}
            schema={this.state.formModel.rules}
            ref={(ref: any) => this.form = ref}
        >
            <Comp.Editors.BooleanField
                formComponent={this}
                name="agreedToUsagePermission"
                description={<p>
                    I give permission for my presentation to be included in a multimedia product.
                    <br />
                    <em>
                        Please note that all slides included in such a multimedia product, will be
                        embedded in the program, making them unable to be altered.
                    </em>
                </p>}
                trueLabel="I agree"
                falseLabel="I disagree"
            />

            <Comp.Editors.BooleanField
                formComponent={this}
                name="agreedToRepurposingContent"
                description={<p>
                    I am interested in discussing the possibility of converting my presentation into an Innovative Surgical Video
                    or Spotlight Case to be shared with the membership for educational purposes.
                </p>}
                trueLabel="I agree"
                falseLabel="I disagree"
            />

            <Comp.Editors.FormField name="" label="Speaker attestation">
                <p>
                    By agreeing to participate as a speaker at ASRS’ Annual meeting, I am attesting that:
                </p>

                <div className="agreement">
                    <SpeakerGuidelines />
                </div>

                <div className={speakerGuidelinesErrors.length ? "field-with-errors" : ""}>
                    <p>
                        <label>
                            <input
                                checked={formModel.data.agreedToSpeakerGuidelines || false}
                                name="agreedToSpeakerGuidelines"
                                type="checkbox"
                                onChange={() => {}}
                            /> I agree to abide by the Speaker Guidelines as detailed above.
                        </label>
                    </p>
                </div>

                <p>
                    In submitting this abstract I give permission for my abstract to be published in the Meeting Program Book
                    and other society publications as well as online.
                </p>

                {speakerGuidelinesErrors.length
                    ? speakerGuidelinesErrors.map((err: string, i) => <div className="field-with-errors" key={i}>{err}</div>)
                    : null}
            </Comp.Editors.FormField>

            <Comp.Editors.SubmitField cancelLink={cancelLink} label="Save" showProcessing={this.state.formProcessing} />

        </Comp.Validation.ValidatedForm>;
    }

    private handleSubmit(model: Forms.AdminAbstract.AbstractPermissionsData) {
        const body = {
            agreedToRepurposingContent: model.agreedToRepurposingContent,
            agreedToSpeakerGuidelines: model.agreedToSpeakerGuidelines,
            agreedToUsagePermission: model.agreedToUsagePermission,
            guid: this.props.abstract.guid,
        };

        this.props.onSubmit(model, body);
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/edit/components/PermissionsForm.tsx